const styles = {
  overAllWrapper: {
    marginBottom: '30px',
  },
  overAllTrippedWarning: {
    padding: '10px',
    fontSize: '1.4em',
    color: 'white',
    background: (theme) => theme.palette?.error.main,
  },
  button: {
    textTransform: 'none',
  },
};

export default styles;
